"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LangSchema = exports.LANG_CHANGE_LANGUAGE = undefined;

var _reduxActions = require("redux-actions");

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

var _reactIntl = require("react-intl");

var _de = require("react-intl/locale-data/de");

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Define the action constants this reducer handles and exports for its actions
// structure is based on https://github.com/erikras/ducks-modular-redux
var LANG_CHANGE_LANGUAGE = exports.LANG_CHANGE_LANGUAGE = "lang/LANG_CHANGE_LANGUAGE";

(0, _reactIntl.addLocaleData)(_de2.default);
// Define the state schema this reducer complies to and export it so this can be reused.
var LangSchema = exports.LangSchema = t.struct({
    locale: t.String,
    parentLocale: t.String,
    messages: t.Object
}, "LangSchema");
// Define the initial state of this reducer (must conform to the above Schema)
var initialState = LangSchema({
    locale: "de",
    parentLocale: "de",
    messages: Object.assign({}, require("../../../i18n/de.json"), require("../../i18n/de.json"))
});
exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, LANG_CHANGE_LANGUAGE, function (state, action) {
    return LangSchema.update(state, {
        locale: {
            $set: action.payload.locale
        },
        messages: {
            $set: action.payload.messages
        }
    });
}), initialState);


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/lang/index.ts
 ** module id = 1291
 ** module chunks = 0
 **/